import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';
import { getTheme, ifProp, parseProp, parseTheme, size } from 'mol-ui';

export const ActionContainer = styled.div`
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    ${ ifProp('highlight', 'font-weight: bold;', '') }
    margin-right: 15px;
    text-decoration: underline;
    ${ size.xs(`
        padding-bottom: 10px;
        padding-top: 10px;
    `) }
`;

export const AuditItem = styled.div`
    border-bottom: 1px solid ${ getTheme('primaryLighterColor') };
    font-size: 11px;
    margin: 0px 0px 5px 0px;
    padding-bottom: 5px;
    :last-child {
        border-bottom: none;
    }
`;

export const Col = styled(Col_)`
    ${ ({ centered }) => !centered ? '' : `
        display: flex;
        justify-content: center;
    ` }
    ${ ({ padding }) => padding ? `padding:${ padding };` : '' }
`;

export const Container = styled.div`
    ${ parseTheme('color', 'textColor') }
    display: flex;
    flex-direction: column;
    max-height: 100%;
    min-width: 340px;
    overflow-y: auto;
    width: 100%;
    @media (min-width: 576px) {
        min-width: 576px;
    }
`;

export const DataContainer = styled.div`
    display: inline-flex;
    flex-direction: ${ ({ flexDirection }) => flexDirection ? flexDirection : 'column' };
    ${ ({ margin }) => margin ? `margin: ${ margin };` : '' }
    width: 100%;
    ${ size.xs(`
        flex-wrap: wrap;
    `) }
`;

export const DisplayErrorMessage = styled.div`
    color: ${ ({ theme: { dangerColor } }) => dangerColor };
    font-weight: bold;
    margin-bottom: 20px;
`;

export const PatientCol = styled(Col_)`
    font-size: 14px;
    margin-top: 10px;
    word-break: break-all;
`;

export const Row = styled(Row_)`
    margin: 0px;
    width: 100%;
`;

export const Subtitle = styled.div `
    font-size: 11px;
    margin-top: 5px;
    ${ parseProp('margin') }
`;

export const Title = styled.div`
    color: ${ ({ theme: { primaryColor } }) => primaryColor };
    font-size: 18px;
`;

export const TurnTypeDisplay = styled.div`
    align-items: center;
    display: flex;
    font-size: 15px;
    height: 100%;
    justify-content: center;
    margin-bottom: 10px;
`;
